import { useEffect, useState } from 'react';
import useCommonProps from '../../../hooks/useCommonProps';
export var useGetVideoRatio = function (link, videoData, videoType) {
    var _a = useState(16 / 9), ratio = _a[0], setRatio = _a[1];
    var viewType = useCommonProps().viewType;
    useEffect(function () {
        if (videoType === 'yt') {
            var width = videoData.width, height = videoData.height, name_1 = videoData.name;
            if (width && height) {
                setRatio(width / height);
            }
        }
        if (['vk', 'rt'].includes(videoType)) {
            var h = (link.match(/height="\s*(\d+)"/) &&
                link.match(/height="\s*(\d+)"/)[1]) ||
                null;
            var w = (link.match(/width="\s*(\d+)"/) &&
                link.match(/width="\s*(\d+)"/)[1]) ||
                null;
            if (w && h) {
                setRatio(w / h);
            }
        }
    }, [viewType, videoData, videoType]);
    return ratio;
};
//# sourceMappingURL=useGetVideoRatio.js.mapimport { useEffect, useState } from 'react';
import useCommonProps from '../../../hooks/useCommonProps';
export var useGetVideoRatio = function (link, videoData, videoType) {
    var _a = useState(16 / 9), ratio = _a[0], setRatio = _a[1];
    var viewType = useCommonProps().viewType;
    useEffect(function () {
        if (videoType === 'yt') {
            var width = videoData.width, height = videoData.height, name_1 = videoData.name;
            if (width && height) {
                setRatio(width / height);
            }
        }
        if (['vk', 'rt'].includes(videoType)) {
            var h = (link.match(/height="\s*(\d+)"/) &&
                link.match(/height="\s*(\d+)"/)[1]) ||
                null;
            var w = (link.match(/width="\s*(\d+)"/) &&
                link.match(/width="\s*(\d+)"/)[1]) ||
                null;
            if (w && h) {
                setRatio(w / h);
            }
        }
    }, [viewType, videoData, videoType]);
    return ratio;
};
//# sourceMappingURL=useGetVideoRatio.js.map